var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPendingToReviewInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.46094 13C6.80612 13 7.08594 12.7202 7.08594 12.375C7.08594 12.0298 6.80612 11.75 6.46094 11.75C6.11576 11.75 5.83594 12.0298 5.83594 12.375C5.83594 12.7202 6.11576 13 6.46094 13Z",
    fill: "#364153"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 8C15.5561 8 15.8359 7.72018 15.8359 7.375C15.8359 7.02982 15.5561 6.75 15.2109 6.75C14.8658 6.75 14.5859 7.02982 14.5859 7.375C14.5859 7.72018 14.8658 8 15.2109 8Z",
    fill: "#364153"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46094 3.625C6.80612 3.625 7.08594 3.34518 7.08594 3C7.08594 2.65482 6.80612 2.375 6.46094 2.375C6.11576 2.375 5.83594 2.65482 5.83594 3C5.83594 3.34518 6.11576 3.625 6.46094 3.625Z",
    fill: "#364153"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46094 9.875C6.46094 7.46667 8.4276 5.5 10.8359 5.5C11.9026 5.5 12.8776 5.88333 13.6359 6.51667L14.4359 5.55833C13.4609 4.74167 12.2026 4.25 10.8359 4.25C7.7276 4.25 5.21094 6.76667 5.21094 9.875C5.21094 10.2 5.24427 10.5167 5.29427 10.8333L6.5276 10.6167C6.48594 10.375 6.46094 10.125 6.46094 9.875Z",
    fill: "#364153"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 9.875C3.33594 7.80833 4.1776 5.93333 5.53594 4.575L4.6526 3.69167C3.06927 5.275 2.08594 7.46667 2.08594 9.875C2.08594 14.7083 6.0026 18.625 10.8359 18.625V17.375C6.7026 17.375 3.33594 14.0083 3.33594 9.875Z",
    fill: "#364153"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8359 2.375C14.9693 2.375 18.3359 5.74167 18.3359 9.875H19.5859C19.5859 5.04167 15.6693 1.125 10.8359 1.125C9.78594 1.125 8.78594 1.31667 7.8526 1.65833L8.2776 2.83333C9.0776 2.54167 9.93594 2.375 10.8359 2.375Z",
    fill: "#364153"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8359 18.9917L18.5359 16.6917C19.0526 16 19.3692 15.1417 19.3692 14.2167C19.3692 11.9167 17.4942 10.0417 15.1942 10.0417C12.8942 10.0417 11.0192 11.9167 11.0192 14.2167C11.0192 16.5167 12.8942 18.3917 15.1942 18.3917C16.1192 18.3917 16.9609 18.0833 17.6526 17.575L19.9526 19.875L20.8359 18.9917ZM12.2692 14.2167C12.2692 12.6 13.5859 11.2917 15.1942 11.2917C16.8026 11.2917 18.1192 12.6083 18.1192 14.2167C18.1192 15.825 16.8026 17.1417 15.1942 17.1417C13.5859 17.1417 12.2692 15.825 12.2692 14.2167Z",
    fill: "#364153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingToReviewInformation);
export default __webpack_public_path__ + "static/media/ic-pending-to-review-information.e3ac96267d3ceba0dacfe3c881da2cec.svg";
export { ForwardRef as ReactComponent };